
import {Actions} from './ts/redux/Actions'

// AWH Once all of CMS View has beenmograted to Typescript, this this file will go away

// ACTIONS
(window as any).ACTION_API_CREATEATTACHMENT_FAIL    = Actions.ACTION_API_CREATEATTACHMENT_FAIL;
(window as any).ACTION_API_CREATEATTACHMENT_START   = Actions.ACTION_API_CREATEATTACHMENT_START;
(window as any).ACTION_API_CREATEATTACHMENT_SUCCESS = Actions.ACTION_API_CREATEATTACHMENT_SUCCESS;

(window as any).ACTION_API_DELETEATTACHMENT_START   = Actions.ACTION_API_DELETEATTACHMENT_START;
(window as any).ACTION_API_DELETEATTACHMENT_FAIL    = Actions.ACTION_API_DELETEATTACHMENT_FAIL;
(window as any).ACTION_API_DELETEATTACHMENT_SUCCESS = Actions.ACTION_API_DELETEATTACHMENT_SUCCESS;


(window as any).ACTION_UI_CREATEATTACHMENT_GET_COORD_START  = Actions.ACTION_UI_CREATEATTACHMENT_GET_COORD_START;
(window as any).ACTION_UI_CREATEATTACHMENT_GET_COORD_STOP   = Actions.ACTION_UI_CREATEATTACHMENT_GET_COORD_STOP;

(window as any).ACTION_UI_CREATEATTACHMENT_GET_FILE_START  = Actions.ACTION_UI_CREATEATTACHMENT_GET_FILE_START;
(window as any).ACTION_UI_CREATEATTACHMENT_GET_FILE_STOP   = Actions.ACTION_UI_CREATEATTACHMENT_GET_FILE_STOP;

(window as any).ACTION_UI_CREATEATTACHMENT_GET_LINK_START  = Actions.ACTION_UI_CREATEATTACHMENT_GET_LINK_START;
(window as any).ACTION_UI_CREATEATTACHMENT_GET_LINK_STOP   = Actions.ACTION_UI_CREATEATTACHMENT_GET_LINK_STOP;


// update attachments
(window as any).ACTION_API_UPDATEATTACHMENT_FAIL      = Actions.ACTION_API_UPDATEATTACHMENT_FAIL;
(window as any).ACTION_API_UPDATEATTACHMENT_START     = Actions.ACTION_API_UPDATEATTACHMENT_START;
(window as any).ACTION_API_UPDATEATTACHMENT_SUCCESS   = Actions.ACTION_API_UPDATEATTACHMENT_SUCCESS;

(window as any).ACTION_SET_SITEMAP_URL                = Actions.ACTION_SET_SITEMAP_URL;
(window as any).ACTION_SET_PUSHPIN_GET_COORD_START    = Actions.ACTION_SET_PUSHPIN_GET_COORD_START;
(window as any).ACTION_SET_PUSHPIN_GET_COORD_STOP     = Actions.ACTION_SET_PUSHPIN_GET_COORD_STOP;
(window as any).ACTION_SET_PUSHPIN_COORD              = Actions.ACTION_SET_PUSHPIN_COORD;
(window as any).ACTION_REMOVE_PUSHPIN_COORD           = Actions.ACTION_REMOVE_PUSHPIN_COORD;

(window as any).ACTION_SET_FETCHING_ASSETS      = Actions.ACTION_SET_FETCHING_ASSETS;
(window as any).ACTION_SET_ASSET_DATA           = Actions.ACTION_SET_ASSET_DATA;
(window as any).ACTION_ADD_FETCHED_ASSETS_FLOOR = Actions.ACTION_ADD_FETCHED_ASSETS_FLOOR;
(window as any).ACTION_SET_WORKORDERS_DATA = Actions.SET_WORKORDERS_DATA;
(window as any).ACTION_SET_CLUSTER_TOGGLE = Actions.ACTION_SET_CLUSTER_TOGGLE;

(window as any).ts_temp__actions = Actions;